import React, { FC } from "react";
import { Letter } from "../../types";
import { selectLetter } from "../../api";

interface SelectKindContentProps {
  setOpenThankYouContent: () => void;
  setOpenImageContent: () => void;
  setOpen: () => void;
  letter: Letter | null;
  hasLetter?: boolean;
  meId?: string;
  setInstructionContent: () => void;
}

const SelectKindContent: FC<SelectKindContentProps> = ({
  setOpenThankYouContent,
  setOpenImageContent,
  setOpen,
  letter,
  hasLetter,
  setInstructionContent,
  meId,
}) => {
  const htmlString = letter?.text as string;
  const doc = { __html: htmlString };
  return (
    <>
      <div className="w-[990px] rounded-2xl bg-white flex items-center p-[44px]">
        <div className="w-[143px]">
          <div className="mt-[-30px]">
            <p className="main-card-hexagon-text text-black text-[76px]">
              {letter?.id}
            </p>
          </div>
          <div className="mt-[80px]">
            <p className="vela-sans text-[16px]">✍️</p>
            <p className="vela-sans text-black text-[16px]">
              {letter?.name || "-"}
            </p>
            <p className="vela-sans text-[#909098] text-[16px]">
              {letter?.age || "-"} {letter && Number(letter.age) > 5 ? "лет" : "года"}
            </p>
          </div>
        </div>
        <div className="w-[371px]">
          <div
            className="html-text text-[22px] vela-sans leading-6"
            dangerouslySetInnerHTML={doc}
          ></div>
        </div>
        <div
          onClick={() => {
            setOpenImageContent();
            setOpen();
          }}
          className="pr-[44px] cursor-pointer pt-[20px] pb-[20px]"
        >
          <div className="w-[331px] rounded flex justify-center relative left-[35px]">
            <img
              src={letter?.image}
              alt="Изображение письма"
              width="200px"
            />
          </div>
        </div>
      </div>
      <div className="w-[990px] h-[103px] rounded-2xl bg-[#3F44D9] mt-[24px] flex items-center">
        <div className="flex-start pl-[44px]">
          {letter?.user ? (
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <path d="M0 32H32V0H0V32Z" fill="url(#pattern0)" />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_6744_3911"
                    transform="scale(0.015625)"
                  />
                </pattern>
                <image
                  id="image0_6744_3911"
                  width="64"
                  height="64"
                  xlinkHref="data:image/png;base64,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"
                />
              </defs>
            </svg>
          ) : (
            <img src="./static/eyes.png" alt="" />
          )}
        </div>
        <div className="flex flex-auto ml-[128px]">
          {letter?.user?.avatar && (
            <img
              className="relative rounded-full mr-[12px]"
              src={letter?.user?.avatar}
              alt="Аватар пользователя"
              width={"40px"}
              height={"40px"}
            />
          )}
          <p className="text-[22px]">
            {letter?.user ? letter.user.name : "Дед мороз  пока не найден️🤷"}
          </p>
        </div>
        {!letter?.user && !hasLetter && (
          <div className="flex-end pr-[44px]">
            <button
              onClick={() => {
                selectLetter(letter?.id as string).then((response) => {
                  setOpenThankYouContent();
                });
              }}
              type="button"
              className="outline-none inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal transition duration-150 ease-in-out bg-white w-[333px] h-[56px] text-[16px]"
            >
              Сделать подарок
            </button>
          </div>
        )}
        {hasLetter && meId === letter?.user_uid && (
          <div className="flex-end pr-[44px]">
            <button
              onClick={setInstructionContent}
              type="button"
              className="outline-none inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal transition duration-150 ease-in-out bg-white w-[333px] h-[56px] text-[16px]"
            >
              Инструкция
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default SelectKindContent;
